import { useQuery } from "react-query";
import { getPaymentTypes } from "../services/finance/paymentType";
import { PagedRequestType } from "../types/PagedResults";
import { Key_paymenttypies } from "../utils/constants";

export const useGetPaymentTypesQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_paymenttypies, JSON.stringify(data)],
    () => getPaymentTypes(data), 
    options?{...options}:{}
  );